import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../lib/i18n';
export function About() {
  const {
    t
  } = useLanguage();
  const SERVICES = [t.svcWebDev, t.svcEcommerce, t.svcAI, t.svcMonthly, t.svcDomain, t.svcEmail, t.svcPerformance, t.svcSEO];
  return <section id="about" className="py-24 md:py-32 px-6 md:px-12 lg:px-20 z-10 relative" data-id="element-16">
      <div className="max-w-[1400px] mx-auto" data-id="element-17">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24" data-id="element-18">
          {/* Left: Text */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          ease: [0.16, 1, 0.3, 1]
        }} data-id="element-19">
            <p className="text-secondary text-xs tracking-[0.2em] uppercase mb-4 font-light" data-id="element-20">
              {t.aboutOverline}
            </p>
            <h2 className="text-2xl md:text-4xl lg:text-5xl font-display font-bold text-primary tracking-tight mb-6 leading-snug" data-id="element-21">
              {t.aboutTitle}
            </h2>
            <p className="text-secondary text-base leading-relaxed font-light mb-6" data-id="element-22">
              {t.aboutP1}
            </p>
            <p className="text-secondary text-base leading-relaxed font-light mb-6" data-id="element-23">
              {t.aboutP2}
            </p>
            <p className="text-secondary text-base leading-relaxed font-light" data-id="element-24">
              {t.aboutP3}
            </p>
          </motion.div>

          {/* Right: Services */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.15,
          ease: [0.16, 1, 0.3, 1]
        }} className="lg:pt-12" data-id="element-25">
            <p className="text-secondary text-xs tracking-[0.2em] uppercase mb-8 font-light" data-id="element-26">
              {t.servicesOverline}
            </p>
            <div className="space-y-0" data-id="element-27">
              {SERVICES.map((service, index) => <motion.div key={service} initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: index * 0.06,
              ease: [0.16, 1, 0.3, 1]
            }} className="flex items-center justify-between py-4 border-b border-border group" data-id="element-28">
                  <span className="text-primary text-base font-light tracking-wide" data-id="element-29">
                    {service}
                  </span>
                  <motion.span className="text-muted text-xs font-light" initial={{
                opacity: 0
              }} whileInView={{
                opacity: 1
              }} viewport={{
                once: true
              }} transition={{
                duration: 0.5,
                delay: 0.5 + index * 0.06
              }} data-id="element-30">
                    0{index + 1}
                  </motion.span>
                </motion.div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}